import ScrollHandler from "../../src/parts/ScrollHandler";
const scrollHandler = new ScrollHandler();

window.addEventListener('DOMContentLoaded', () => {
    let headerEl = document.querySelector('#header');        

    // Mobile Scripts
    let mobileToggleCollapsed = headerEl.querySelector('#menu-toggle-collapsed-mobile');
    let mobileToggleExpanded = headerEl.querySelector('#menu-toggle-expanded-mobile');

    mobileToggleCollapsed.addEventListener('click', () => {
        headerEl.querySelector('#menu-main-mobile').setAttribute('active', true);
        headerEl.querySelector('#menu-main-links-mobile').setAttribute('active', true);
        if (headerEl.querySelector('.subnav.mobile')) {
            headerEl.querySelector('.subnav.mobile #menu-sub-buttons').setAttribute('active', true);
            headerEl.querySelector('.subnav.mobile').setAttribute('active', true);
        }
        headerEl.setAttribute("expanded", "true");
        mobileToggleExpanded.setAttribute('active', true);
        mobileToggleCollapsed.setAttribute('active', false);
        scrollHandler.disableScroll();
    });

    mobileToggleExpanded.addEventListener('click', () => {
        headerEl.querySelector('#menu-main-mobile').setAttribute('active', false);
        headerEl.querySelector('#menu-main-links-mobile').setAttribute('active', false);
        if (headerEl.querySelector('.subnav.mobile')) {
            headerEl.querySelector('.subnav.mobile #menu-sub-buttons').setAttribute('active', false);
            headerEl.querySelector('.subnav.mobile').setAttribute('active', false);
        }        
        headerEl.setAttribute("expanded", "false");
        mobileToggleCollapsed.setAttribute('active', true);
        mobileToggleExpanded.setAttribute('active', false);
        scrollHandler.enableScroll();
    });
});